import React__default from 'react';
import Box from '../Box/Box.js';

const labelTextStyles = {
  alignSelf: 'center',
  gridArea: '1 / 2 / 2 / 3'
};
const AtlasLabelText = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    sx: labelTextStyles
  }, children);
};
AtlasLabelText.displayName = "AtlasLabelText";
const requiredIndicatorStyles = {
  paddingLeft: '2px',
  color: 'text.danger.default'
};
const RequiredIndicator = () => {
  return /*#__PURE__*/React__default.createElement(Box, {
    as: "span",
    sx: requiredIndicatorStyles,
    "aria-hidden": true
  }, "*");
};
RequiredIndicator.displayName = "RequiredIndicator";

export { AtlasLabelText, RequiredIndicator };
